class AppConsts {
  static host = 'https://360.stafflow.by:5201';
}

export default AppConsts;
